import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ArkikProductsState } from './arkik-products.models';

export const selectArkikProductsState = createFeatureSelector<ArkikProductsState>('arkikProducts');

export const selectArkikProducts = createSelector(selectArkikProductsState, (state) => state.products);

export const selectArkikProductsLoading = createSelector(selectArkikProductsState, (state) => state.loading);

export const selectArkikProductsError = createSelector(selectArkikProductsState, (state) => state.error);
